import { RouteConfig } from 'vue-router';

import PageInvoices from './PageInvoices.vue';

export default {
  path: 'list',
  name: 'invoices',
  component: PageInvoices,
  meta: {
    title: 'Notas fiscais',
  },
} as RouteConfig;
